function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import NavDrawerLink from './NavDrawerLink';
import Icon from '../Icon';
import updateGlobalListeners from '../utils/updateGlobalListeners';

var NavDrawerItem = /*#__PURE__*/function (_React$Component) {
  _inherits(NavDrawerItem, _React$Component);

  var _super = _createSuper(NavDrawerItem);

  function NavDrawerItem(props) {
    var _this;

    _classCallCheck(this, NavDrawerItem);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      var onItemClick = _this.props.onItemClick;
      var expanded = _this.state.expanded;

      if (e.target === e.currentTarget) {
        _this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            expanded: !expanded
          });
        });
      }

      onItemClick();
    });

    _defineProperty(_assertThisInitialized(_this), "onToggle", function () {
      var onItemClick = _this.props.onItemClick;
      var expanded = _this.state.expanded;

      _this.setState({
        expanded: !expanded
      });

      onItemClick();
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyPress", function (e) {
      e.stopPropagation();
      e.preventDefault();
      var expanded = _this.state.expanded;

      if (e.target === e.currentTarget && e.key === 'Enter') {
        _this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            expanded: !expanded
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleEventsOutOfBounds", function (event) {
      var domNode = _this.node;

      if (!domNode || !domNode.contains(event.target)) {
        _this.setState(function (prevState) {
          return _objectSpread({}, prevState);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateNode", function (node) {
      _this.node = node;
    });

    _defineProperty(_assertThisInitialized(_this), "updateChildrenWithActiveProp", function (children, active, parentIndex) {
      return React.Children.map(children, function (child) {
        return React.cloneElement(child, {
          active: active,
          parentIndex: parentIndex
        });
      });
    });

    _this.state = {
      expanded: props.expanded,
      id: props.id ? props.id : Math.floor(Math.random() * 1000000)
    };
    return _this;
  }

  _createClass(NavDrawerItem, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var expanded = this.state.expanded;

      if (expanded === true) {
        updateGlobalListeners('add', ['keydown', 'click'], this.handleEventsOutOfBounds, true);
      } else {
        updateGlobalListeners('remove', ['keydown', 'click'], this.handleEventsOutOfBounds, true);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      updateGlobalListeners('remove', ['keydown', 'click'], this.handleEventsOutOfBounds, true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          href = _this$props.href,
          children = _this$props.children,
          name = _this$props.name,
          badge = _this$props.badge,
          index = _this$props.index,
          isAccordion = _this$props.isAccordion,
          routerLink = _this$props.routerLink,
          level = _this$props.level,
          active = _this$props.active,
          onClick = _this$props.onClick,
          onKeyPress = _this$props.onKeyPress,
          onToggle = _this$props.onToggle; // eslint-disable-next-line react/destructuring-assignment

      var _ref = this.props.id ? this.props : this.state,
          id = _ref.id;

      var _ref2 = level === 1 ? this.state : this.props,
          expanded = _ref2.expanded;

      var navdraweritemID = "navdraweritem-".concat(id);
      var accordionID = "navdraweritemaccordion-".concat(id);
      var navDrawerLiClass = cx({
        navdrawer__ul__li: true,
        'navdrawer__item--active': active
      });
      var navDrawerItemClass = cx({
        navdrawer__item: true,
        'navdrawer__item--expanded': expanded
      });
      var navDrawerUlClass = cx({
        navdrawer__ul: true,
        navdrawer__accordion: isAccordion,
        'navdrawer__accordion--expanded': isAccordion && expanded
      });
      var rowIcon = expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
      return /*#__PURE__*/React.createElement("li", {
        ref: function ref(node) {
          return _this2.updateNode(node);
        },
        className: navDrawerLiClass,
        id: navdraweritemID,
        role: "none"
      }, name && /*#__PURE__*/React.createElement("div", {
        className: navDrawerItemClass
      }, href ? /*#__PURE__*/React.createElement(NavDrawerLink, {
        href: href,
        name: name,
        badge: badge,
        isAccordion: isAccordion,
        routerLink: routerLink,
        hasChildren: children && children.length > 0,
        onKeyPress: onKeyPress || this.onKeyPress,
        onClick: onClick || this.onClick,
        onToggle: onToggle,
        active: active,
        controls: accordionID,
        tabIndex: 0
      }) : /*#__PURE__*/React.createElement("div", {
        role: "button" // eslint-disable-next-line react/destructuring-assignment
        ,
        "aria-expanded": this.state.expanded,
        tabIndex: 0,
        className: "navdrawer__heading",
        onClick: this.onToggle,
        onKeyPress: this.onToggle
      }, name), isAccordion && /*#__PURE__*/React.createElement(Icon, {
        name: rowIcon,
        className: "position-absolute right-lg align-self-center",
        onClick: this.onToggle,
        onKeyPress: this.onKeyPress,
        tabIndex: 0
      })), children && /*#__PURE__*/React.createElement("ul", _extends({
        className: navDrawerUlClass
      }, isAccordion && {
        id: accordionID,
        'aria-expanded': expanded
      }), this.updateChildrenWithActiveProp(children, active, index)));
    }
  }]);

  return NavDrawerItem;
}(React.Component);

_defineProperty(NavDrawerItem, "propTypes", {
  active: PropTypes.bool,
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.any,
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  badge: PropTypes.number,
  isAccordion: PropTypes.bool,
  routerLink: PropTypes.bool,
  id: PropTypes.string,
  tabIndex: PropTypes.number,
  level: PropTypes.number,
  open: PropTypes.bool,
  expanded: PropTypes.bool,
  onToggle: PropTypes.func,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
  onItemClick: PropTypes.func
});

_defineProperty(NavDrawerItem, "defaultProps", {
  routerLink: true,
  active: false,
  expanded: false,
  onItemClick: function onItemClick() {}
});

NavDrawerItem.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onToggle",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onKeyPress",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleEventsOutOfBounds",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "updateNode",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "node",
      "type": null
    }],
    "returns": null
  }, {
    "name": "updateChildrenWithActiveProp",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "children",
      "type": null
    }, {
      "name": "active",
      "type": null
    }, {
      "name": "parentIndex",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "NavDrawerItem",
  "props": {
    "routerLink": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "active": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "expanded": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onItemClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "href": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "index": {
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "badge": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "isAccordion": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "tabIndex": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "level": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "open": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onToggle": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onKeyPress": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
export default NavDrawerItem;